import { Typography } from "@mui/material";

interface Props {
  title: string;
}

const Header = (props: Props) => {
  return (
    <>
      <Typography variant="h5" align="center" gutterBottom>
        {props.title}
      </Typography>
    </>
  );
};

export default Header;
